import { Box } from '@mui/material';

// imports: assets
import { ReactComponent as CopyDetail } from 'core/assets/svg/modal-icons/copy-detail.svg';
import BaseTypography from 'core/components/typography/BaseTypography';
import { LayoutOrientation } from 'core/constants/enums/LayoutOrientation.ts';

// imports: constants
import { ReusedComponentIDs } from 'core/constants/enums/ReusedComponentIDs.ts';
import { ToastType } from 'core/constants/enums/ToastTypeEnum.ts';
import { sendToast } from 'core/layouts/components/toast/ToastUtils';

// imports: components
import ActionsMenu from 'apps/studio/studio-tab/components/actions-menu/ActionsMenu';
import ImageInfoBottomBar from 'apps/studio/studio-tab/components/image-info/components/ImageInfoBottomBar';

// imports: styles
import { imageInfoStyles } from 'apps/studio/studio-tab/components/image-info/ImageInfoStyles';
import { reusableStyles } from 'core/layouts/ui-blocks/ReusableStyles';
import React from 'react';

// imports: utils
import { copyToClipboard } from 'core/utils/utils';

export const styles = imageInfoStyles;
export default function BasicInfo(props) {
	const { selectedPrompt, handleClose, feedPromptsModalType } = props;
	return (
		<Box id="details-cont" sx={styles.basicDetailsCont}>
			<Box id="details-scroll-wrapper" sx={[styles.promptDetailsScrollWrapper]}>
				<Box id="prompt-details" sx={styles.detailScreenPromptDetails}>
					<Box id={ReusedComponentIDs.PROMPT_MODAL_SCROLL_IDHAR} />
					<ActionsMenu
						image={selectedPrompt?.media}
						orientation={LayoutOrientation.HORIZONTAL}
						handleClose={handleClose}
						imageId={selectedPrompt?.generationId}
					/>

					<Box sx={[styles.detailCard]}>
						<Box id="seed_data" sx={[reusableStyles.flexCol]}>
							<Box
								sx={[
									reusableStyles.flexRow,
									{
										width: '100%',
										marginBottom: '6px',
										justifyContent: 'space-between',
									},
								]}
							>
								<BaseTypography variant="b1_medium" styles={{ color: 'colors.light2' }}>
									Seed
								</BaseTypography>

								<Box sx={[reusableStyles.flexRow, { gap: '12px' }]}>
									<Box sx={[styles.detailValue]}>
										<BaseTypography variant="b1_regular" styles={{ color: 'colors.light3' }}>
											{selectedPrompt.seed}
										</BaseTypography>
									</Box>
									<Box
										sx={styles.copyDetailButton}
										onClick={(e) => {
											e.stopPropagation();
											sendToast(ToastType.VALUE_COPIED);
											copyToClipboard(selectedPrompt.seed);
										}}
									>
										<CopyDetail />
									</Box>
								</Box>
							</Box>
						</Box>
					</Box>
				</Box>
			</Box>
			<ImageInfoBottomBar
				selectedPrompt={selectedPrompt}
				handleClose={handleClose}
				feedPromptsModalType={feedPromptsModalType}
				showPublishPrompt={false}
				showReusePrompt={false}
			/>
		</Box>
	);
}
